import {
  BufferTrackerReact as BufferTracker,
  Client,
} from '@buffer-mono/tracking-plan'
import type { Account } from '../../common/types'
import { getOrganization } from '../../common/utils/user'
import {
  getCommonTrackingPropertiesFromAccount,
  shouldPerformTrackingEvent,
} from '../utils'

export default function trackBrainfishClosed({
  user,
}: {
  user: Account
}): void {
  const canPerformTrackingEvent = shouldPerformTrackingEvent({
    user,
  })

  if (!canPerformTrackingEvent) {
    return
  }

  const organization = getOrganization(user)
  const commonTrackingProperties = getCommonTrackingPropertiesFromAccount(user)

  const eventData = {
    ...commonTrackingProperties,
    clientName: Client.PublishWeb,
    organizationId: organization?.id || '',
    currentUrl: window.location.href,
  }

  BufferTracker.brainfishWidgetClosed(eventData)
}
